export interface TeachingLanguage {
  language: string
  level: string
}

export function getTeachingLanguages(
  languages?: TeachingLanguage[],
  legacyEnglishLevel?: string,
): TeachingLanguage[] {
  if (languages?.length) return languages
  if (!legacyEnglishLevel) return []

  return [{
    language: 'English',
    level: legacyEnglishLevel.toLowerCase() === 'native'
      ? 'Native'
      : legacyEnglishLevel.toUpperCase(),
  }]
}

export function getTeachingLanguageSummary(
  languages?: TeachingLanguage[],
  legacyEnglishLevel?: string,
): string {
  const teachingLanguages = getTeachingLanguages(languages, legacyEnglishLevel)
  return teachingLanguages.length
    ? teachingLanguages.map(item => `${item.language} · ${item.level}`).join(', ')
    : '-'
}
